import { apiClient } from './client';
import type {
  CreateDashboardBlockRequest,
  CreateDashboardRequest,
  CreateBlockFromPromptRequest,
  Dashboard,
  DashboardBlock,
  DashboardBlockData,
  DashboardCatalogEntry,
  DashboardDepartmentOption,
  DashboardFormatterMeta,
  UpdateDashboardBlockRequest,
  UpdateDashboardLayoutRequest,
  UpdateDashboardRequest,
} from '@pm-next/shared-types';

export async function listDashboards(): Promise<Dashboard[]> {
  const { data } = await apiClient.get<Dashboard[]>('/dashboards');
  return data;
}

export async function getDashboard(id: string): Promise<Dashboard> {
  const { data } = await apiClient.get<Dashboard>(`/dashboards/${id}`);
  return data;
}

export async function createDashboard(body: CreateDashboardRequest): Promise<Dashboard> {
  const { data } = await apiClient.post<Dashboard>('/dashboards', body);
  return data;
}

export async function updateDashboard(
  id: string,
  body: UpdateDashboardRequest
): Promise<Dashboard> {
  const { data } = await apiClient.patch<Dashboard>(`/dashboards/${id}`, body);
  return data;
}

export async function deleteDashboard(id: string): Promise<void> {
  await apiClient.delete(`/dashboards/${id}`);
}

export async function updateDashboardLayout(
  id: string,
  body: UpdateDashboardLayoutRequest
): Promise<Dashboard> {
  const { data } = await apiClient.put<Dashboard>(`/dashboards/${id}/layout`, body);
  return data;
}

export async function getDashboardCatalog(): Promise<DashboardCatalogEntry[]> {
  const { data } = await apiClient.get<DashboardCatalogEntry[]>('/dashboards/catalog');
  return data;
}

export async function getDashboardFormatters(): Promise<DashboardFormatterMeta[]> {
  const { data } = await apiClient.get<DashboardFormatterMeta[]>('/dashboards/formatters');
  return data;
}

export async function listDashboardDepartments(): Promise<DashboardDepartmentOption[]> {
  const { data } = await apiClient.get<DashboardDepartmentOption[]>('/dashboards/departments');
  return data;
}

export async function addDashboardBlock(
  dashboardId: string,
  body: CreateDashboardBlockRequest
): Promise<DashboardBlock> {
  const { data } = await apiClient.post<DashboardBlock>(`/dashboards/${dashboardId}/blocks`, body);
  return data;
}

export async function addDashboardBlockFromPrompt(
  dashboardId: string,
  body: CreateBlockFromPromptRequest
): Promise<DashboardBlock> {
  const { data } = await apiClient.post<DashboardBlock>(
    `/dashboards/${dashboardId}/blocks/from-prompt`,
    body
  );
  return data;
}

export async function updateDashboardBlock(
  dashboardId: string,
  blockId: string,
  body: UpdateDashboardBlockRequest
): Promise<DashboardBlock> {
  const { data } = await apiClient.patch<DashboardBlock>(
    `/dashboards/${dashboardId}/blocks/${blockId}`,
    body
  );
  return data;
}

export async function deleteDashboardBlock(dashboardId: string, blockId: string): Promise<void> {
  await apiClient.delete(`/dashboards/${dashboardId}/blocks/${blockId}`);
}

export async function getDashboardBlockData(
  dashboardId: string,
  blockId: string,
  params?: { page?: number; pageSize?: number }
): Promise<DashboardBlockData> {
  const { data } = await apiClient.get<DashboardBlockData>(
    `/dashboards/${dashboardId}/blocks/${blockId}/data`,
    { params }
  );
  return data;
}
